import { h } from 'preact';

export const ANIMATION_DURATION = 500
export const generateIngredientsList = (items) =>
    items?.length > 0 ? (
      <ul className='list-none flex flex-col gap-[5px] laptop:gap-[10px] uppercase'>
        {items.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
  ) : null;

export const functionDelay = ({
  fn,
  value = undefined,
  delay = ANIMATION_DURATION,
}) => {
  const timer = setTimeout(() => {
    fn(value);
  }, delay);
  return () => clearTimeout(timer);
};

export const toggleDocumentScroll = (isScrollEnabled) => {
  const OFF_SCROLL_CLASS_NAME = 'disable-scroll'
  if (isScrollEnabled) {
    document.querySelector('body').classList.remove(OFF_SCROLL_CLASS_NAME);
    document.querySelector('html').classList.remove(OFF_SCROLL_CLASS_NAME);
    return
  }
  document.querySelector('body').classList.add(OFF_SCROLL_CLASS_NAME);
  document.querySelector('html').classList.add(OFF_SCROLL_CLASS_NAME);
}
